export const BulkPrefixes = {
  Editor: 'bulk-editor',
  Page: 'bulk-page',
  Recipients: 'bulk-recipients',
  Allotments: 'bulk-allotments',
};
